import React from "react"
import { Link } from "gatsby"
import { TwitterFollowButton } from 'react-twitter-embed';

export default function Footie() {
  return(
    <footer className="footer">
      
      <div className="uk-background-secondary uk-padding-small">

        <p className="uk-text uk-padding-small uk-padding-remove-top uk-padding-remove-bottom footerText">
          Copyright © {new Date().getFullYear()} ϕpost.  All rights reserved.
        </p> 

        <hr></hr>  
        
        <div className="uk-child-width-expand@s uk-grid uk-padding-remove uk-margin-remove" data-uk-grid="">
              <div className="uk-first-column uk-padding-small uk-padding-remove-top uk-padding-remove-bottom">
                <Link to="/about">
                  <div className="uk-panel footerText">About Us</div>
                </Link>
                <Link to="/feedback">
                  <div className="uk-panel footerText">Give Us Some Feedback</div>
                </Link>   
                <Link to="/tips">
                  <div className="uk-panel footerText">Share Tips Anonymously</div>
                </Link>            
                <Link to="/newsletter">
                  <div className="uk-panel footerText">Sign Up For Our Weekly Newsletter</div>
                </Link>    
              </div>

              <div className="uk-visible@s"></div>

              <div className="uk-padding-small uk-padding-remove-top uk-padding-remove-bottom">
                <Link to="/privacy">
                  <div className="uk-panel footerText">Privacy Notice</div>
                </Link>  
                <Link to="/tos">
                  <div className="uk-panel footerText">Terms of Use</div>
                </Link>  
                <Link to="/rss.xml">
                  <div className="uk-panel footerText">RSS Feed</div>
                </Link>  
                <TwitterFollowButton
                  screenName={'phi_post'}
                  options={{
                    'size': 'small',
                    'showCount': 'false'
                  }}
                />
              </div>
        </div>

      </div>
    </footer>
  )
}